import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { transactionsTypes } from 'companion-app-components/flux/transactions';

import QIconButton from 'components/QIconButton';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface SaveFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const SaveField: FC<SaveFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  editable,
  SHOW_ALL,
  fieldActive,
  txn,
  focusField,
}) => {
  const { classes } = useStyles();
  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      onClick={forceStatic ? null : () => callbacks.handleMenu?.('save', txn)}
      className={classNames(classes.iconButtonColumn, forceStatic ? 'nopoint skinny' : 'skinny')}
    >
      {editable && SHOW_ALL &&
        <QIconButton
          aria-label="Save Transaction"
          autoFocus={fieldActive}
          focusRipple
          ref={fieldActive ?
            (input) => {
              focusField.current = input; // eslint-disable-line
            } : null}
          disabled={forceStatic}
          IconComponent={SaveOutlinedIcon}
          IconProps={{
            className: classNames(classes.reviewed, 'save'),
          }}
          size="small-target"
          tooltip="Save Transaction"
          TooltipProps={{ distance: 2 }}
        />}
    </RegListItem>
  );
};

export default SaveField;
